import React from 'react'
import styled from 'styled-components'
import { BLUE, PRIMARY_COLOR } from '../../../styles/colors.style'

const ProductQuantitySelector = ({
	productQuantity,
	handleProductDecrease,
	handleProductIncrease,
	qttMin,
	qttMax,
}) => {
	return (
		<Container>
			<QuantityDecreaseButton
				onClick={handleProductDecrease}
				disabled={productQuantity == qttMin}>
				<span>-</span>
			</QuantityDecreaseButton>
			<QuantityDisplay>{productQuantity}</QuantityDisplay>
			<QuantityIncreaseButton
				onClick={handleProductIncrease}
				disabled={productQuantity == qttMax}>
				<span>+</span>
			</QuantityIncreaseButton>
		</Container>
	)
}

const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-right: 10px;
	border: 1px solid ${PRIMARY_COLOR};
	border-radius: 6px;

	button {
		border: none;
		cursor: pointer;
		transition: background 0.2s;
		background-color: transparent;
		height: -webkit-fill-available;
		width: 50px;

		&:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}

		&:not(:disabled):hover {
			background: ${PRIMARY_COLOR};

			span {
				color: #fff;
			}
		}

		span {
			font-size: 20px;
			color: ${PRIMARY_COLOR};
			font-weight: bold;
		}
	}
`

const QuantityIncreaseButton = styled.button`
	border-radius: 0px 6px 6px 0px;
`

const QuantityDecreaseButton = styled.button`
	border-radius: 6px 0px 0px 6px;
`

const QuantityDisplay = styled.span`
	min-width: 24px;
	text-align: center;
	font-size: 18px;
`

export default ProductQuantitySelector
